import { Instagram, Facebook, Music2 } from "lucide-react";
import { SunLogo } from "../components/SunLogo";
import { INFO } from "../data/info";
import { LangSwitcher } from "../components/LangSwitcher";
import { useLang } from "../i18n";

const SOCIALS = [
  { Icon: Instagram, href: INFO.instagram, label: "Instagram", id: "instagram" },
  { Icon: Facebook, href: INFO.facebook, label: "Facebook", id: "facebook" },
  { Icon: Music2, href: INFO.tiktok, label: "TikTok", id: "tiktok" },
];

export const Footer = () => {
  const { t } = useLang();

  return (
    <footer data-testid="site-footer" className="relative bg-[#2B1E16] px-6 pb-12 pt-24 md:px-12 md:pt-32">
      <div className="grain absolute inset-0" />
      <div className="relative mx-auto max-w-[1400px]">
        <div className="flex flex-col items-center text-center">
          <SunLogo animate={false} className="h-14 w-auto" />
          <p className="brand-latin mt-6 font-sans text-xs uppercase tracking-[0.5em] text-[#F5EDE3]" dir="ltr">Deseos</p>
          <p className="brand-latin mt-2 font-sans text-[9px] uppercase tracking-[0.4em] text-[#F5EDE3]/45" dir="ltr">Speciality Coffee</p>

          <div className="mt-10 flex gap-7">
            {SOCIALS.filter((s) => s.href && s.href !== "#").map(({ Icon, href, label, id }) => (
              <a
                key={id}
                data-testid={`footer-social-${id}`}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={label}
                className="text-[#D9B98A]/70 transition-all duration-300 hover:-translate-y-0.5 hover:text-[#D9B98A] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D9B98A]"
              >
                <Icon size={19} strokeWidth={1.5} />
              </a>
            ))}
          </div>

          <div className="mt-12 h-[1px] w-full max-w-md bg-[#D9B98A]/25" />

          <div className="mt-8 flex flex-col items-center gap-2 font-sans text-[10px] uppercase tracking-[0.24em] text-[#F5EDE3]/40">
            <p>
              {INFO.address} · {INFO.city}
            </p>
            <p>{t.footer.hours}</p>
          </div>

          <LangSwitcher className="mt-8" />

          <p className="mt-10 font-sans text-[9px] uppercase tracking-[0.2em] text-[#F5EDE3]/25">
            © {new Date().getFullYear()} Deseos Brunch &amp; Coffee
          </p>

          <p className="mt-3 font-sans text-[9px] uppercase tracking-[0.2em] text-[#F5EDE3]/25">
            {t.footer.credit}{" "}
            <a
              data-testid="footer-credit-sourati"
              href="https://sourati.digital"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#D9B98A]/60 transition-colors duration-300 hover:text-[#D9B98A] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D9B98A]"
            >
              Sourati Digital
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
